module.exports = __webpack_public_path__ + "img/antes_despues_100.8d77ec35.png";